'use client';

import { faFlag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

import { Button } from '@/components/atoms';
import { CaptainChallengeForm } from '@/components/forms';
import { ModalWrapper } from '@/components/organisms';
import { CaptainChallengeData } from '@/components/schemas';

interface CaptainChallengeModalProps {
	title: string;
	dateTime: string;
	homeTeam: string;
	awayTeam: string;
}

export const CaptainChallengeModal = ({ title, dateTime, homeTeam, awayTeam }: CaptainChallengeModalProps) => {
	const [showModal, setShowModal] = useState<boolean>(false);

	const toggleModal = () => {
		setShowModal((prev) => !prev);
	};

	const handleFormSubmit = (data: CaptainChallengeData) => {
		console.log('Challenge Data:', data);
		// TODO-tala: Implement challenge submission logic
		toggleModal();
	};

	return (
		<>
			<Button
				className="!h-8 flex min-w-64 items-center justify-center gap-1 border border-gray-300 !bg-white text-gray-900 transition-all duration-200 shadow-xs hover:border-gray-400 hover:bg-gray-50 hover:shadow-sm sm:w-auto"
				onClick={toggleModal}
			>
				<FontAwesomeIcon icon={faFlag} className="size-4" />
				<span>Captain&apos;s score challenge</span>
			</Button>

			{showModal && (
				<ModalWrapper
					overlayClassName="z-10"
					className="max-w-[500px]"
					title="Captain's Challenge"
					onClose={toggleModal}
					closeOnOutsideClick={true}
				>
					<CaptainChallengeForm
						onSubmit={handleFormSubmit}
						onClose={toggleModal}
						title={title}
						dateTime={dateTime}
						homeTeam={homeTeam}
						awayTeam={awayTeam}
					/>
				</ModalWrapper>
			)}
		</>
	);
};
